import {
  PATIENT_TAB_MAX_WIDTH,
  PATIENT_TAB_MIN_WIDTH,
} from "./components/PatientTab";
import type { PatientTabsResponse_Tab } from "./network/usePatientTabs";

export const isSelected = (
  tab: PatientTabsResponse_Tab,
  patientId?: string,
  encounterId?: string,
) => {
  return (
    (Boolean(encounterId) && tab.encounter?.id === encounterId) ||
    (Boolean(patientId) && tab.patient.id === patientId && !encounterId)
  );
};

export const findOtherPatientTabs = (tabs: PatientTabsResponse_Tab[]) => {
  return tabs.map((tab) => {
    const hasOtherOpenTabs = !!tabs.find(
      ({ patient, encounter }) =>
        patient.id === tab.patient.id && encounter?.id !== tab.encounter?.id,
    );

    return { ...tab, hasOtherOpenTabs };
  });
};

export const calculateDisplayedAndHiddenTabs = <T>({
  tabs,
  containerWidth,
  reservedWidth = 0,
}: {
  tabs: T[];
  containerWidth: number;
  reservedWidth?: number;
}) => {
  const availableWidthForTabs = Math.max(0, containerWidth - reservedWidth);
  const idealTabWidth = availableWidthForTabs / tabs.length;
  const tabWidth = Math.max(
    PATIENT_TAB_MIN_WIDTH,
    Math.min(PATIENT_TAB_MAX_WIDTH, idealTabWidth),
  );

  const totalAvailableTabs = Math.floor(availableWidthForTabs / tabWidth);

  return {
    displayed: tabs.slice(0, totalAvailableTabs),
    hidden: tabs.slice(totalAvailableTabs),
  };
};
